import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Image,
  VStack,
  HStack,
  Button,
  Text,
  Pressable,
} from "native-base";
import { Linking } from "react-native";
import { LinkIcon } from "../../../assets/icons/icon-assets";

const LinkPreview = ({ url, imageHeight, width, height }) => {
  const [previewData, setPreviewData] = useState<any>(null);
  const [error, setError] = useState<any>(null);

  React.useEffect(() => {
    let isMounted = true;

    const fetchLinkPreview = async () => {
      try {
        const response = await axios.get("https://api.linkpreview.net", {
          params: {
            key: "fa7a7a675495a6cc97dac00c791ddb6b",
            q: url,
          },
        });

        if (isMounted) {
          setPreviewData(response.data);
        }
      } catch (error) {
        if (isMounted) {
          setPreviewData({
            url: url,
            image:
              "https://pixabay.com/get/g01794082f3aba6bdb82a9dd31150d59c485636408c6905c1e41577160666f71af8695230d502ae7afb8cf86486960915.svg",
          });
        }
      }
    };

    fetchLinkPreview();

    return () => {
      isMounted = false;
    };
  }, [url]);

  if (error) {
    return <div>{error}</div>;
  }

  if (!previewData) {
    return <div>Loading...</div>;
  }

  return (
    <Box
      width={width}
      height={height}
      borderRadius="8px"
      overflow="hidden"
      shadow="2"
    >
      <VStack>
        <Box position="relative">
          {previewData.image?.trim()?.length > 0 &&
          previewData.image !== undefined &&
          !previewData.image.endsWith(".svg") ? (
            <Image
              source={previewData.image}
              alt={previewData.title}
              width="100%"
              height={imageHeight}
            />
          ) : (
            <HStack backgroundColor="gray.200">
              <LinkIcon
                height={imageHeight == "60px" ? "110" : "220"}
                width={"100%"}
              />
            </HStack>
          )}
        </Box>
        <Box padding="3" backgroundColor="#f5f5f5">
          <Pressable onPress={() => Linking.openURL(previewData.url)}>
            <Text
              fontSize="12px"
              color="#888"
              fontWeight={"400"}
              marginBottom="1"
              numberOfLines={2}
            >
              {previewData.url}
            </Text>
            <Text fontSize="14px" color="#333" fontWeight="bold">
              {previewData.title}
            </Text>
          </Pressable>
        </Box>
      </VStack>
    </Box>
  );
};

export default LinkPreview;
